import React, {ReactNode, useEffect, useState} from 'react'
import { Elements } from '@stripe/react-stripe-js';
import {loadStripe, Stripe} from "@stripe/stripe-js";
import {useTranslation} from "react-i18next";
import {StripeElementLocale} from "@stripe/stripe-js/dist/stripe-js/elements-group";
import { getStripePublicKey } from '../utils/stripe-public-key';
import { Checkout } from '../types/checkout';

type Props = {
    children: ReactNode;
    checkout: Checkout;
}
export const StripeProvider: React.FC<Props> = ({children, checkout}) => {
    const { i18n } = useTranslation();
    const publicKey = getStripePublicKey(checkout);
    const [stripePromise, setStripePromise] = useState<Promise<Stripe | null>>(new Promise<null>(() => {}))
    useEffect(() => {
        setStripePromise(loadStripe(publicKey, {
            locale: i18n.language as StripeElementLocale || 'auto',
        }));
    }, [i18n.language, publicKey]);
    return <Elements key={`${i18n.language}:${publicKey}`} stripe={stripePromise}>
        {children}
    </Elements>
}
